import React from 'react';
import { connect } from 'react-redux';
import {
  Form,
  FormGroup,
  Button,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  Field,
  FieldArray,
  reduxForm,
  stopSubmit,
  formValueSelector,
  getFormValues,
} from 'redux-form';

import SelectDropdown from '../../../system/fields/SelectDropdown';
import Repeater from '../../../system/fields/Repeater';
import TextInput from '../../../system/fields/TextInput';
import Wysiwyg from '../../../system/fields/Wysiwyg';

import DestinationLegs from './DestinationLegs';
import TravelLegs from './TravelLegs';
import GuideLegs from './GuideLegs';

import * as validations from '../../../system/utils/Validation';
import CruiseLegs from './CruiseLegs';
import LegsWrapper from './Legs';

const selector = formValueSelector('DealForm');

class Options extends React.Component {
  constructor(props, option, index, fields,OIndex, legType) {
    super(props);
  }
  state = {
    activeTab: 1,
  };

  remove(index) {
    const result = window.confirm('Are you sure you want to remove this row?');
    if (result) {
      this.props.fields.remove(index);
    }
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const index = this.props.index;
    const option = this.props.option;
    const options = this.props.options;
    const fields = this.props.fields;

    return (
      <section className='edit-form'>
        <div className='top-field'>
          <Field
            name={`${option}.name`}
            type='text'
            component={TextInput}
            valueKey='value'
            labelKey='name'
            placeholder='Option Name'
          />{' '}
          <Field
            name={`${option}.order`}
            type='text'
            component={TextInput}
            valueKey='value'
            labelKey='name'
            placeholder='Option Name'
          />
          <Field
            name={`${option}.description`}
            type='text'
            component={Wysiwyg}
            valueKey='value'
            labelKey='name'
            placeholder='Option Name'
          />
          <FieldArray name={`${option}.legs`} component={renderLegs} OIndex={this.props.OIndex} />
        </div>
      </section>
    );
  }
}

const renderLegs = ({ fields,OIndex, meta: { touched, error } }) => (
  <div className='repeater-container pb-5 mb-5'>
    {fields.map((leg, index) => (
      <LegsWrapper leg={leg} fields={fields} index={index} key={index}  OIndex={OIndex}/>
    ))}

    <div className='add-button bottom'>
      <Button type='button' onClick={() => fields.push({ leg_type: '' })}>
        Add Leg
      </Button>
    </div>
  </div>
);

const OptionsWrapper = connect((state, props) => ({
  name: selector(state, `${props.option}.name`),
  options: selector(state, 'options'),
}))(Options);

export default OptionsWrapper;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/Options.jsx